import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { startRedirect, validate360Start } from "store/actions";
import FullPageLoader from "App/common/ui/FullPageLoader";

function Idrive360(props) {
  useEffect(() => {
    props.startRedirect(false);
    if (props.location.pathname.split("/")[3]) {
      props.validate360Start(
        props.location.pathname.split("/")[3],
        props.logout,
        props.location.search.split("=")[1] === "signup" ? true : false
      );
    }

    return () => props.startRedirect(false);
  }, []);
  let content = null;

  if (props.auth.redirect) {
    content = <Redirect to="/mirror/login" />;
  } else if (
    props.auth.validate360 &&
    props.auth.validate360.success === false
  ) {
    content = <div>{props.auth.validate360.message}</div>;
  } else {
    content = <FullPageLoader />;
  }
  return content;
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      validate360Start,
      startRedirect
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Idrive360);
